export enum BmarkOrderDataEventOperation {
  NEW,
  DELETE,
  XFER,
  UPDATE,
  BATCH_UPDATE,
  NOTIFICATION,
  LOCK_UPDATE,
  NETTING_UPDATE,
  OE_DI_NEEDED, // life-cycle
  OE_DI_NEW, // intervention
  OE_DI_APPROVE, // intervention
  OE_DI_REJECT, // intervention
  OE_CLEAR, // replaces orderEntryClearEventSubject
  OE_ERROR, // replaces orderEntryErrorEventSubject
}

export namespace BmarkOrderDataEventOperation {
  let elements = [
    BmarkOrderDataEventOperation.NEW,
    BmarkOrderDataEventOperation.DELETE,
    BmarkOrderDataEventOperation.XFER,
    BmarkOrderDataEventOperation.UPDATE,
    BmarkOrderDataEventOperation.BATCH_UPDATE,
    BmarkOrderDataEventOperation.NOTIFICATION,
    BmarkOrderDataEventOperation.LOCK_UPDATE,
    BmarkOrderDataEventOperation.NETTING_UPDATE,
    BmarkOrderDataEventOperation.OE_DI_NEEDED,
    BmarkOrderDataEventOperation.OE_DI_NEW,
    BmarkOrderDataEventOperation.OE_DI_APPROVE,
    BmarkOrderDataEventOperation.OE_DI_REJECT,
    BmarkOrderDataEventOperation.OE_CLEAR,
    BmarkOrderDataEventOperation.OE_ERROR,
  ];
  let alias = "com.bcdfx.model.BmarkFixingOperation";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
